export default __webpack_public_path__ + "adcbfbb892596d80fae12bc35ad764f4.otf";